module.exports = __webpack_public_path__ + "img/section1.8f70132e.jpg";